const ROADMAP_ITEMS = [
    {
        done: true,
        title: 'Antal personer online',
    },
    {
        done: true,
        title: 'Autofokus på sökfältet',
    },
    {
        done: true,
        title: 'Visa personer i mötesrum',
    },
    {
        done: true,
        title: 'Pinna kollegor',
    },
    {
        done: true,
        title: 'Smartare namn: stavningsvarianter och efternamnsinitial',
    },
    {
        done: false,
        title: 'Mer information om mötesrummen',
    },
    {
        done: false,
        title: 'Slackintegration',
    },
    {
        done: false,
        title: 'Visa återkommande vs enstaka möten',
    },
    {
        done: false,
        title: 'Status på vattenkokare',
    },
    {
        done: false,
        title: 'Se flera dagar framåt',
    },
    {
        done: false,
        title: 'Bring back marodörkartan',
    },
];

const SORTED_ROADMAP_ITEMS = [ ...ROADMAP_ITEMS ].sort( ( a, b ) => {
    return ( b.done ? 1 : 0 ) - ( a.done ? 1 : 0 );
} );

const REQUESTS_URL = 'https://iodigitalcom.slack.com/archives/D0CAFJM2S6B';

function Roadmap() {
    return (
        <div className="roadmap">
            <div className="roadmap-header">
                <h2>Roadmap</h2>
            </div>
            <p className="roadmap-intro">Det här är klart och det här är på gång i L0LC4tor.</p>
            <ul className="roadmap-list">
                { SORTED_ROADMAP_ITEMS.map((item) => (
                    <li
                        key = { item.title }
                        className = { `roadmap-item${ item.done ? ' roadmap-item-done' : '' }` }
                    >
                        <span
                            className = { 'roadmap-checkbox' }
                            aria-hidden = { 'true' }
                        >
                            { item.done ? '✓' : '' }
                        </span>
                        <span className="roadmap-item-title">{ item.title }</span>
                    </li>
                )) }
                <li className = "roadmap-item roadmap-item-request">
                    <a
                        className = "roadmap-request-link"
                        href = { REQUESTS_URL }
                        target = "_blank"
                        rel = "noopener noreferrer"
                    >
                        <span
                            className = { 'roadmap-checkbox' }
                            aria-hidden = { 'true' }
                        />
                        <span className = "roadmap-item-title">
                            Saknar du något? Skriv i <span className = "roadmap-request-channel">#got-lolcator</span> på Slack
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default Roadmap;
